export default {
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    /**
     * 更新模板状态
     * @param {String} relationId 关联关系编号
     * @param {String | Number} status 状态，1编辑，2发布
     * @param {String} role 角色
     * @param {Boolean} isOverride 是否覆盖
     * CASE_ADMIN("case_admin", "案件管理员"),
     * MEDIATOR("mediator", "调解员"),
     * AGENT("agent", "代理人"),
     * ORG_ADMIN("org_admin", "机构管理员"),
     * OPERATION("operation", "运营"),
     */
    updateTemplateStatus(relationId, status, role = '',  isOverride = true) {
      const params = {
        relationId,
        status,
        isOverride,
        role
      };
      this.$api.updateTemplateStatus(params).then(res => {
        if (res.code === 200) {
          this.$message.success(`${(/1/).test(status) ? '撤回' : '发布'}成功`);
          // 刷新列表
          this.clickSearchHandler();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  }
};
